import React from "react";
import ImageComponent from "../../common/ImageComponent";
import {
  getGroupColor,
  getGroupImageTag,
  isBaseCoreElement,
} from "../../../../helpers/utils";
import appStyles from "../../../appStyles";
import ManaIcon from "../../common/icons/ManaIcon";

export default function ElementIcon({
  element,
  style = {},
  onPress = () => {},
  onLongPress = () => {},
}) {
  let ImageTag = ImageComponent;
  let activityName = element?.name;
  let baseElementIconStyle = {};
  if (isBaseCoreElement(activityName)) {
    ImageTag = getGroupImageTag(activityName);

    baseElementIconStyle = {
      backgroundColor: getGroupColor(activityName),
      borderRadius: 100,
    };
  }

  return element.icon === "mana" ? (
    <ManaIcon
      style={[appStyles.activityIcon, style]}
      icon={element.icon}
      onPress={onPress}
      onLongPress={onLongPress}
      width={24}
      height={24}
    />
  ) : (
    <ImageTag
      style={[appStyles.activityIcon, baseElementIconStyle, style]}
      icon={element.icon}
      onPress={onPress}
      onLongPress={onLongPress}
      width={24}
      height={24}
    />
  );
}
